const BIRTH_COUPONS = 'birthCoupons';

export const storeBirthCoupons = function (birthCoupons) {
  try {
    localStorage.setItem(BIRTH_COUPONS, JSON.stringify(birthCoupons));
  } catch (e) {}
};

export const getBirthCoupons = function () {
  let birthCoupons = localStorage.getItem(BIRTH_COUPONS);
  try {
    birthCoupons = JSON.parse(birthCoupons);
    if (birthCoupons && birthCoupons?.length > 0) {
      return birthCoupons;
    } else {
      return [];
    }
  } catch (e) {
    return [];
  }
};
